import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
// import cookie from 'js-cookie'

/* LIB FUNCTIONS */
// import useCore from '../../lib/useCore'
import useNotFound from '../../lib/useNotFound'
import devExtremeLocalization from '../../lib/devExtremeLocalization'
/* COMPONENTS */
import BPHeader from '../layout/BPHeader'
import Content from '../layout/Content'
import { userSelector, useUserStore } from 'store/userInfo.store'

const PageLayout = ({ children }) => {
  // const { user } = useCore()
  const currentUser = useUserStore(userSelector)
  // const userLang = useUserStore(langSelector)
  const pageNotFound = useNotFound()
  const { i18n } = useTranslation()
  const [initialized, setInitialized] = useState(false)

  const handleUserLanguageChange = () => {
    if (!initialized) {
      // if (cookie) {
      //   const userLanguage = cookie.get('lang')
      //   if (userLanguage) {
      //     devExtremeLocalization(userLanguage)
      //     i18n && i18n.changeLanguage(userLanguage)
      //   }
      // }
      // if(userLang){
      //   devExtremeLocalization(userLang)
      //   i18n && i18n.changeLanguage(userLang)
      // }
      const userLanguage = localStorage.getItem("webshop-lang")
      i18n.changeLanguage(userLanguage || "tr")
      devExtremeLocalization(userLanguage)

      setInitialized(true)
    }
  }
  const cbHandleUserLanguageChange = useCallback(handleUserLanguageChange, [])

  useEffect(() => {
    cbHandleUserLanguageChange()
  }, [cbHandleUserLanguageChange])

  if (Number(currentUser?.id) >0 && !pageNotFound) {
    return (
      <div className='page-wrapper'>
        <div className='page-inner'>
          {/* <Sidebar /> */}
          <div className='page-content-wrapper'>
            <BPHeader />
            <Content>
              {children}
            </Content>
            {/* <Footer /> */}
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <>
        {children}
      </>
    )
  }
}
export default PageLayout
